import { POLICY_OPTIONS } from "../../utils/constants/uiConstants";

/**
 * Determines if a field should be rendered based on a simple numeric policy.
 * Semantics are kept identical to the existing checks:
 * - undefined or 0 → visible
 * - any value other than HIDE → visible
 * - HIDE → not visible
 */
export const shouldShowField = (policy?: number | null): boolean => {
  if (policy === POLICY_OPTIONS.HIDE) return false;
  return true;
};

/**
 * "Loose" mandatory check – matches existing places where
 * undefined / 0 / VISIBLE_AND_MANDATORY are all treated as mandatory.
 */
export const isFieldMandatoryLoose = (policy?: number | null): boolean => {
  return (
    policy === undefined ||
    policy === 0 ||
    policy === POLICY_OPTIONS.VISIBLE_AND_MANDATORY
  );
};

/**
 * "Strict" mandatory check – matches existing places where ONLY
 * explicit VISIBLE_AND_MANDATORY (and not 0 / undefined) is mandatory.
 */
export const isFieldMandatoryStrict = (policy?: number | null): boolean => {
  return (
    policy !== undefined &&
    policy !== 0 &&
    policy === POLICY_OPTIONS.VISIBLE_AND_MANDATORY
  );
};

/**
 * Like shouldShowField, but also hides the field when the policy key is
 * absent from the team/product data entirely (undefined, null, or 0) —
 * unlike shouldShowField, undefined/0 does NOT default to visible here.
 */
export const shouldShowFieldIfPolicyPresent = (
  policy?: number | null
): boolean => {
  if (policy === undefined || policy === null || policy === 0) return false;
  return shouldShowField(policy);
};
